import React      from 'react'
import AnchorLink from './AnchorLink'

export const SummaryStat = ({
  stats      = [],
  statname   = ''
}) => {

  const statsMap = {
    'tries': 'goal icon-font-before icon-rugby-solid-before icon-rugby-solid',
    'conversiongoals': 'goal icon-font-before icon-rugby-conversion-solid-before icon-rugby-conversion-solid',
    'penalties': 'goal icon-font-before icon-rugby-penalty-solid-before icon-rugby-penalty-solid',
    'yellowcards': 'icon-font-before icon-soccer-card02-solid-before icon-yellowcard',
    'redcards': 'icon-font-before icon-soccer-card02-solid-before icon-redcard',
    'dropgoalsconverted': 'goal icon-font-before icon-rugby-drop-goal-solid-before icon-rugby-drop-goal-solid'
  }

  if (stats.length === 0 || statsMap.hasOwnProperty(statname) === false) {
    return (
      <script />
    )
  }

  let statNodesMarkup = []

  for (let playerId in stats) {
    const playerStat = stats[playerId]
    const times = '(' + playerStat.times.join(', ') + ')'
    statNodesMarkup.push(
      <li key={playerId}>
        {
          playerStat.link &&
          <AnchorLink target="_blank" to={ playerStat.link }>{ playerStat.name }</AnchorLink>
          ||
          <span style={ { fontWeight:600 } }>{playerStat.name}</span>
        }
        <span>{ times }</span>
      </li>
    )
  }

  return (
    <ul className={ statsMap[statname] } >
      { statNodesMarkup }
    </ul>
  )
}

export const TeamSummary = ({
  team      = {},
  how       = 'home'
}) => {

  const summaryStats = []
  for (let stat in team) {
    summaryStats.push(
      <SummaryStat key={ stat } stats={ team[stat] } statname={ stat } />
    )
  }

  return (
    <div className={ 'team ' + how }>
      <div className="team-info players">
        { summaryStats }
      </div>
    </div>
  )
}

export const EventSummary = ({
  summary      = {}
}) => {
  return (
    <div className="competitors">
      <TeamSummary team={ summary.home } how="away" />
      <TeamSummary team={ summary.away } how="home" />
    </div>
  )
}

export default EventSummary



/** WEBPACK FOOTER **
 ** ../app/components/common/EventSummary.jsx
 **/